import Menu from './Compartido/Menu.jsx';
import TextosCanceladoTpv from './CanceladoTpv/TextosCanceladoTpv.jsx';
import Footer from './Compartido/Footer.jsx';

const CanceladoTpv = (props) => {
    return (
        <main>
            <Menu
                destinos={props.destinos}
                sobrenosotros={props.textosobrenosotros}
                clientes={props.textoclientes}
                propietarios={props.textopropietarios}
                servicios={props.textoservicios}
                experiencias={props.experiencias}
                idiomas={props.idiomas}
                lang={props.lang}
                tiposcasas={props.tiposcasas}
                config={props.config}
                textopropiedades={props.textopropiedades}
                edificios={props.edificios}
                marcas={props.marcas}
                ruta={props.ruta}
            />
            <TextosCanceladoTpv />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    )
}

export default CanceladoTpv;
